$( window ).ready(function() {

    $( '.chart-panel:not(.is-active)' ).addClass('hide');

    $( '.chart-select' ).change(function () 
    {
        //console.log( $( this ).parent().find( '.chart-panel' ) );

        var minHeight = $( this ).parent().find( '.chart-panel.is-active' ).height();

        $( this ).parents( '.chart-parent' ).find( '.chart-panel' ).addClass( 'hide' );
        $( this.value ).removeClass( 'hide' );
        // $( this.value ).trigger( 'updateChart' );
    });
});